import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-transaction-chicken-test-modal',
  templateUrl: './transaction-chicken-test.component.html',
  styleUrls: [],
})
export class TransactionChickenTestComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<TransactionChickenTestComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    console.log(this.data);
  }

  _continue() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {}
}
